<template>
  <v-app>
    <core-app-bar />

    <core-drawer />
    <notifications
      group="notify"
      position="center "
      :max="3"
      :width="500"
    />
    <core-view />
    <core-footer />
  </v-app>
</template>

<script>
  export default {
    name: 'App',

    components: {
      CoreDrawer: () => import('@/components/core/Drawer'),
      CoreFooter: () => import('@/components/core/Footer'),
      CoreAppBar: () => import('@/components/core/AppBar'),
      CoreView: () => import('@/components/core/View'),
    },
  }
</script>
